import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import Home from "./pages/Home/Home";
import Loader from "./components/shared/Loader/Loader";
import About from "./pages/About/About";
import Law from "./pages/Law/Law";
import News from "./pages/News/News";
import NewsDetails from "./pages/NewsDetails/NewsDetails";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PagesManager from "./features/cms/pages/PagesManager";
import BlogManager from "./features/cms/blog/BlogManager";
import CasesManager from "./features/cms/cases/CasesManager";
import SectionsManager from "./features/cms/sections/SectionsManager";
import SectionEditor from "./features/cms/sections/SectionEditor";
import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { LanguageProvider } from "./context/LanguageContext";
import Report from "./pages/Report/Report";
import ReportSubmitted from "./pages/ReportSubmitted/ReportSubmitted";
import Track from "./pages/Track/Track";
import { queryClient } from "./lib/queryClient";
import PublicContentPrefetcher from "./components/shared/PublicContentPrefetcher/PublicContentPrefetcher";
import NavigationProgress from "./components/shared/NavigationProgress/NavigationProgress";
import PublicLayout from "./layouts/PublicLayout/PublicLayout";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <BrowserRouter>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ToastProvider>
              {isLoading && <Loader onFinish={() => setIsLoading(false)} />}
              <PublicContentPrefetcher />
              <NavigationProgress />
              <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/law" element={<Law />} />
                <Route path="/news" element={<News />} />
                <Route path="/news/:id" element={<NewsDetails />} />
                <Route path="/report" element={<Report />} />
                <Route path="/report/submitted" element={<ReportSubmitted />} />
                <Route path="/track" element={<Track />} />
              </Route>

              <Route path="/login" element={<LoginPage />} />

              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/dashboard/pages" element={<PagesManager />} />
                <Route path="/dashboard/blog" element={<BlogManager />} />
                <Route path="/dashboard/cases" element={<CasesManager />} />
                <Route
                  path="/dashboard/pages/:pageId/sections"
                  element={<SectionsManager />}
                />
                <Route
                  path="/dashboard/sections/:sectionId"
                  element={<SectionEditor />}
                />
              </Route>
            </Routes>
          </ToastProvider>
        </AuthProvider>
        </QueryClientProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
